import { PRD4011_R01PlcStatusDto } from "./Dto_PRD4011_R01";

interface Props {
    data: PRD4011_R01PlcStatusDto;
}

/** PLC 상태 — 설비명 | 전원 | 에러 */
export const PlcStatus_PRD4011_R01 = ({ data }: Props) => {
    const errorText = data.isError
        ? `[${data.errorValue ?? ""}] ${data.messageNm ?? "등록되지 않은 에러"}`
        : "";

    return (
        <div className="h-[88px] grid grid-cols-[1.3fr_1fr_1fr] bg-white border border-[#d7dde8] rounded-lg overflow-hidden">
            {/* 설비명 */}
            <div className="flex flex-col justify-center gap-[2px] px-[20px] bg-[#edf3fb] text-[#173d73]">
                <span className="text-[28px] font-extrabold leading-tight">
                    {data.equipNm} 설비 상태
                </span>
                {data.isError && (
                    <span className="text-[14px] font-bold text-[#a51d24] truncate">{errorText}</span>
                )}
            </div>

            {/* 전원 */}
            <div className="flex items-center justify-center gap-[8px] border-l border-[#d7dde8]">
                <span
                    className={`w-[36px] h-[36px] inline-flex items-center justify-center rounded-full text-white ${
                        data.isPowerOn ? "bg-[#1f9d4c]" : "bg-[#8a94a3]"
                    }`}
                >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.8" strokeLinecap="round">
                        <path d="M12 3v8" />
                        <path d="M6.3 7.3a8 8 0 1 0 11.4 0" />
                    </svg>
                </span>
                <span className="text-[22px] font-extrabold text-[#19365f]">전원</span>
                {data.isPowerOn ? (
                    <span className="inline-flex items-center gap-[6px] px-[14px] py-[4px] rounded-full bg-[#17803d] text-white text-[20px] font-extrabold">
                        <span className="w-[10px] h-[10px] rounded-full bg-white" />
                        ON
                    </span>
                ) : (
                    <span className="inline-flex items-center gap-[6px] px-[14px] py-[4px] rounded-full bg-[#eceff3] text-[#334155] text-[20px] font-extrabold">
                        <span className="w-[10px] h-[10px] rounded-full bg-[#8a94a3]" />
                        OFF
                    </span>
                )}
            </div>

            {/* 에러 */}
            <div className="flex items-center justify-center gap-[8px] border-l border-[#d7dde8]">
                <span className="w-[36px] h-[36px] inline-flex items-center justify-center text-[#d92d35]">
                    <svg width="34" height="34" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M10.3 3.6 1.9 18a2 2 0 0 0 1.7 3h16.8a2 2 0 0 0 1.7-3L13.7 3.6a2 2 0 0 0-3.4 0z" />
                        <path d="M11 9h2v5h-2z" fill="#ffffff" />
                        <path d="M11 16h2v2h-2z" fill="#ffffff" />
                    </svg>
                </span>
                <span className="text-[22px] font-extrabold text-[#19365f]">에러</span>
                {data.isError ? (
                    <span className="inline-flex items-center gap-[6px] px-[14px] py-[4px] rounded-full bg-[#c62828] text-white text-[20px] font-extrabold">
                        <span className="w-[10px] h-[10px] rounded-full bg-white" />
                        발생
                    </span>
                ) : (
                    <span className="inline-flex items-center gap-[6px] px-[14px] py-[4px] rounded-full bg-[#eceff3] text-[#334155] text-[20px] font-extrabold">
                        <span className="w-[10px] h-[10px] rounded-full bg-[#8a94a3]" />
                        미발생
                    </span>
                )}
            </div>

        </div>
    );
};
